import React, { useEffect, useState, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';

const ApprovalRmTickets = ({
  fetchRmTicket = null,
  rmTicket = null,
  postUpdateRMStatus,
  rmTicketFilter,
  getRmTicketsFilterDropDown,
}) => {
  const headers = [
    'RM Ticket ID',
    'Complain ID',
    'FD Ticket ID',
    'Created On',
    'Assigned To',
    'Site Number',
    'Client Name',
    'Area Name',
    'Feedback Rating',
    'Feedback Remark',
    'Status',
    'Actions',
  ];

  const [listData, setListData] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          <img src={Images?.Filter} alt=""></img>
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };
  useEffect(() => {
    const installationCont = JSON.parse(
      localStorage.getItem("rmTicketCont") &&
        localStorage.getItem("rmTicketCont")
    );
    if(installationCont){
      localStorage.setItem("rmList", JSON.stringify(""));
      localStorage.setItem("rmTicketCont", 0);
    }
    
  }, []);

  const applyFilter = async (filterData) => {
    localStorage.setItem("rmList", JSON.stringify(filterData));
    setIsLoading(true);
    setFilterData(filterData);
    await fetchRmTicket(filterData, 1, true);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    (async () => {
      if (fetchRmTicket) {
        const dashBoardFilter = await JSON.parse(
          localStorage.getItem("dashBoardFilter") &&
            localStorage.getItem("dashBoardFilter")
        );
        const getcontractFilter = await JSON.parse(
          localStorage.getItem("rmList") &&
            localStorage.getItem("rmList")
        );
        setIsLoading(true);
        // setFilterData({
        //   site_no: '',
        //   client_name: '',
        //   site_type: '',
        //   status: (dashBoardFilter && dashBoardFilter.status)?dashBoardFilter.status:[3, 5],
        //   assignee_ids: '',
        //   fd_ticket_id: "",
        //   fusion_ticket_id: "",
        //   fromDate: (dashBoardFilter && dashBoardFilter.fromFilterDate)?dashBoardFilter.fromFilterDate:'',
        //   toDate: (dashBoardFilter && dashBoardFilter.toFilterDate)?dashBoardFilter.toFilterDate:'',
        // });
        if(dashBoardFilter){
          await fetchRmTicket({
            site_no: '',
            client_name: '',
            site_type: '',
            status: (dashBoardFilter && dashBoardFilter.status)?dashBoardFilter.status:[3, 5],
            assignee_ids: '',
            city_id:"",
            fd_ticket_id: "",
            fusion_ticket_id: "",
            fromDate: (dashBoardFilter && dashBoardFilter.fromFilterDate)?dashBoardFilter.fromFilterDate:'',
            toDate: (dashBoardFilter && dashBoardFilter.toFilterDate)?dashBoardFilter.toFilterDate:'',
          },1,true);
        }
        else if(getcontractFilter){
          await fetchRmTicket(getcontractFilter,1,true);
        }
        else{
          await fetchRmTicket({
            site_no: '',
            client_name: '',
            site_type: '',
            status: (dashBoardFilter && dashBoardFilter.status)?dashBoardFilter.status:[3, 5],
            assignee_ids: '',
            fd_ticket_id: "",
            city_id:"",
            fusion_ticket_id: "",
            fromDate: (dashBoardFilter && dashBoardFilter.fromFilterDate)?dashBoardFilter.fromFilterDate:'',
            toDate: (dashBoardFilter && dashBoardFilter.toFilterDate)?dashBoardFilter.toFilterDate:'',
          },1,true);
        }
       
        await getRmTicketsFilterDropDown(3);
        setIsLoading(false);
        localStorage.setItem("dashBoardFilter", JSON.stringify(''));
      }
    })();
  }, [fetchRmTicket]);

  useEffect(() => {
    (async () => {
      if (refresh === true) {
        setIsLoading(true);
        await fetchRmTicket({
          site_no: '',
          client_name: '',
          site_type: '',
          status: [3, 5],
          fromDate:'',
          toDate:'',
          assignee_ids: '',
        },1,true);
        setIsLoading(false);
      }
    })();
  }, [refresh]);
  const onPageChange = async (val) => {
    setIsLoading(true);
    if(filterData === null){
      await fetchRmTicket({
        site_no: '',
        client_name: '',
        site_type: '',
        status: [3, 5],
        assignee_ids: '',
        fromDate:'',
        toDate:'',
        fd_ticket_id: "",
        city_id:"",
        fusion_ticket_id: "",
      }, val.selected + 1,true);
    }else{
      await fetchRmTicket(filterData, val.selected + 1,true);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    const actions1 = [
      { name: 'View Details', link: '/dashboard/rm-view', showButtons: false },
      { name: 'Ticket Log', link: '/dashboard/rm-log' },
      { name: 'Update RCA', link: '/dashboard/update-rm-closed/3' },
      { name: 'Approval Req', link: '/dashboard/rm-closed/5' },
      { name: 'Reject', link: '' },
    ];

    const tableData = [
      'id',
      'complaint_id',
      'fd_ticket_id',
      'created_at',
      'assigned_to',
      'site_no',
      'client_name',
      'area_name',
      'feedback_rating',
      'feedback_remark',
      'status',
    ];
    if (rmTicket && rmTicket.resultSets) {
      const data = rmTicket.resultSets.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            Action:
              element.status === 'Completed'
                ? [
                    {
                      name: 'View Details',
                      link: '/dashboard/rm-view',
                      showButtons: false,
                    },
                  { name: 'Ticket Log', link: '/dashboard/rm-log' },

                  ]
                : actions1,
          }
        )
      );
      setListData(data);

      setPageCount(Math.ceil(rmTicket.total / rmTicket.per_page));
    }
  }, [fetchRmTicket, rmTicket, refresh]);

  return (
    <Layout
      title={localization.approvalRmTickets}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={true}
        headers={headers}
        pageCount={pageCount}
        srNo={rmTicket?.from}
        onPageChange={onPageChange}
        detailList={rmTicket && rmTicket.resultSets}
        postUpdateRMStatus={postUpdateRMStatus}
        refreshPage={(val) => {
          if (val === true) {
            setRefresh(true);
          }
        }}
      />

      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={''}
        listFilterData={rmTicketFilter?.sites ? rmTicketFilter : null}
        rmTicketFilter
      />
    </Layout>
  );
};

export default ApprovalRmTickets;

